// import 'whatwg-fetch';
import request from 'superagent';

// Direct inspiration:
// https://github.com/jakemmarsh/react-rocket-boilerplate/blob/master/app/js/utils/APIUtils.js

const ApiUtil = {

  // get(path, data = {}) {
  //   return new Promise((resolve, reject) => {
  //     fetch(path, data)
  //       .then(function (resp) {
  //         return resp.json();
  //       })
  //       .then(function (resp) {
  //         if (resp && resp.status === 'success') {
  //           resolve(resp);
  //         } else {
  //           reject(resp);
  //         }
  //       })
  //   });
  // },

  get(path, data = null) {
    return new Promise((resolve, reject) => {
      request.get(path, data)
      .end((err, res) => {
        if (err || !res.ok) {
          reject(err || res);
        } else {
          resolve(res);
        }
      });
    })
  },

  post(path, body) {
    return new Promise((resolve, reject) => {
      request.post(path, body)
      .end((err, res) => {
        if (err || !res.ok) {
          reject(err || res);
        } else {
          resolve(res);
        }
      });
    });
  },

  put(path, body) {
    return new Promise((resolve, reject) => {
      request.put(path, body)
      .end((err, res) => {
        if (err || !res.ok) {
          reject(err || res);
        } else {
          resolve(res);
        }
      });
    });
  },

  del(path, body) {
    return new Promise((resolve, reject) => {
      request.del(path, body)
      .end((err, res) => {
        if (err || !res.ok) {
          reject(err || res);
        } else {
          resolve(res);
        }
      });
    });
  },

}; 


export default ApiUtil;



// WEBPACK FOOTER //
// ./src/ui/util/ApiUtil.js